import React, { useState } from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Button } from '@mui/material'
import { ChargingSessionModelV1 } from 'src/Libs/e-mobility/charging-sessions'
import ExportChargingSessionsMenu from './ExportChargingSessionsMenu'

interface ExportChargingSessionsButtonProps {
  sessions: ChargingSessionModelV1[]
}

/**
 * Button component for exporting charging session.
 * It opens menu with export options (CSV, PDF...)
 * @param sessions array of ChargingSessionModel
 * @return JSX Element
 */
const ExportChargingSessionsButton: React.VFC<ExportChargingSessionsButtonProps> = ({ sessions }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isOpen = Boolean(anchorEl)
  const { t } = useCustomTranslation()

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (): void => {
    setAnchorEl(null)
  }

  return (
    <>
      <Button color="primary" variant="contained" onClick={handleClick} disableElevation>
        {t('emobility.chargingSession.export-sessions')}
      </Button>
      <ExportChargingSessionsMenu isOpen={isOpen} anchorEl={anchorEl} handleClose={handleClose} sessions={sessions} />
    </>
  )
}

export default ExportChargingSessionsButton
